import { Col, Row, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { PieChart, Pie, BarChart, XAxis, YAxis, Legend, Bar, Cell, CartesianGrid } from 'recharts'
import { attackType } from '../../../../shared/enums'
import './css/print-final.css'

const RADIAN = Math.PI / 180
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  return (
    <text x={x} y={y} fill='white' textAnchor={x > cx ? 'start' : 'end'} dominantBaseline='central'>
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  )
}

const COLORS = ['#ea5545', '#f46a9b', '#ef9b20', '#edbf33', '#ede15b', '#bdcf32', '#87bc45', '#27aeef', '#b33dc6']

const GraphFinal = props => {
  const [data, setData] = useState([])
  const [derivedData, setDerivedData] = useState({})
  const [winsData, setWinsData] = useState([])

  useEffect(() => {
    const newDerivedData = {
      attacks: []
    }

    const newWinsData = []

    const winsSize = props?.participants?.length < 8 ? props?.participants?.length : 8

    for (let i = 0; i < winsSize; i += 1) {
      newWinsData.push(Object.assign({}, props.participants[i], { full_name: `${props.participants[i].last_name}, ${props.participants[i].first_name}` }))
    }

    setWinsData(newWinsData)

    const particpantData = props.participants.map((participant) => {
      Object.keys(participant.stats.advanced.for).forEach(key => {
        const index = newDerivedData.attacks.findIndex(a => a.id === key)
        if (index < 0) {
          newDerivedData.attacks.push({
            id: key,
            value: participant.stats.advanced.for[key],
            name: attackType[key.toLowerCase()].name
          })
        }
      })
      return Object.assign({}, participant, { full_name: `${participant.last_name}, ${participant.first_name}` })
    })

    console.log(particpantData)

    setData(particpantData)
    setDerivedData(newDerivedData)
    // eslint-disable-next-line
  }, [props.participants])

  return (
    <div>
      <Row style={{ padding: '2em 0' }}>
        {derivedData?.attacks?.length > 0
          ? (
            <>
              <Col span={24} style={{ textAlign: 'center' }}><h2>Actions Breakdown</h2></Col>
              <Col span={24}>
                <PieChart width={400} height={400} style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
                  <Legend />
                  <Pie
                    data={derivedData.attacks}
                    dataKey='value'
                    cx='50%'
                    cy='50%'
                    labelLine={false}
                    label={renderCustomizedLabel}
                    fill='#8884d8'
                    isAnimationActive={false}
                  >
                    {derivedData?.attacks?.map((entry, index) => {
                      return <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    })}
                  </Pie>
                </PieChart>
              </Col>
            </>
            )
          : ''}
        <Col span={24} style={{ textAlign: 'center' }}><h2>TOP 8</h2></Col>

        <Col span={24}>
          <BarChart
            width={1400}
            height={350}
            data={winsData}
            style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}
            isAnimationActive={false}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey='full_name' interval={0} angle='-45' height={100} textAnchor='end' sclaeToFit='true' verticalAnchor='start' />
            <YAxis label={{ value: 'WINS', angle: '270' }} />
            <Tooltip />
            <Bar dataKey='stats.standard.wins' name='Wins' fill={COLORS[0]} />
          </BarChart>
        </Col>

      </Row>
      <Col span={24} style={{ textAlign: 'center' }}><h2>ALL COMPETITORS</h2></Col>
      <Row>
        <Col span={24}>
          <BarChart
            width={1400}
            height={350}
            data={data}
            style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}
            isAnimationActive={false}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey='full_name' interval={0} angle='-45' height={100} textAnchor='end' sclaeToFit='true' verticalAnchor='start' />
            <YAxis label={{ value: 'POINTS', angle: '-90', position: 'insideLeft' }} yAxisId='left' orientation='left' stroke={COLORS[7]} />
            <YAxis label={{ value: 'HONOR', angle: '90', position: 'insideRight' }} yAxisId='right' orientation='right' stroke={COLORS[5]} />
            <Tooltip />
            <Bar dataKey='tournamentPointsAdjusted' name='Points' yAxisId='left' fill={COLORS[7]} />
            <Bar dataKey='stats.honor' name='Honor' yAxisId='right' fill={COLORS[5]} />
          </BarChart>
        </Col>

      </Row>
    </div>
  )
}

export default GraphFinal
